<app-header
  (ionChange)="onIonChange($event)"
  *ngIf="showHeader"
></app-header>

<ion-content scrollbar class="ion-content-padding-top-0">
  <ion-grid class="no-padding-grid-box" *ngIf="info.length > 0">
    <ion-row justify-content-center>
      <ion-col class="desktop-header">
        <ion-grid class="box">
          <ion-row class="small-padding info-padding" justify-content-center>
            <ion-col class="full-width no-padding">
              <div
                *ngFor="let item of info"
                [ngClass]="'header-option-container' + (currentMenu == item ? ' active' : ' no-active')"
              >
                <ion-item
                  [ngClass]="'input header-option-title click' + (currentMenu == item ? ' header-option-selected' : '')"
                  lines="none"
                  (click)="currentMenu = item"
                >
                  <ion-text>{{item.name}}</ion-text>
                </ion-item>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
      <ion-col class="content-container">
        <ion-grid *ngIf="currentMenu">
          <ion-row class="small-padding" justify-content-center>
            <ion-col class="full-width">
              <div class="position-relative">
                <img
                  #header
                  [src]="currentMenu.imageHeaderUrl ? currentMenu.imageHeaderUrl : bannerImageUrl"
                  class="info__image-header"
                  [ngClass]="{'info__image-header--first-section': currentMenu.name == info[0].name}"
                /> 
                

                <h1 class="info__image-title">{{currentMenu.name}}</h1>
              </div>
              <div class="info__questions-container">
                <div
                  *ngFor="let item of currentMenu.questions"
                  class="info__question"
                >
                  <div
                    class="info__question-title ion-text-center"
                    *ngIf="item.title"
                  >
                  {{item.title}}
                  </div>

                  <div
                    class="info__question-content-wrapper"
                    [innerHTML]="item.content | sanitizeHtml"
                  >
                </div>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ng-container *ngIf="infoLoaded">
    <no-result [collection]="info" text="NO_DATA_TO_SHOW"> </no-result>
  </ng-container>

  <div class="spin" *ngIf="!infoLoaded">
    <app-loading-sti></app-loading-sti>
  </div>
</ion-content>
